/**
 * Reduce any common phone entry to the 10 national digits.
 * Accepts "8655551234", "(865) 555-1234", "865.555.1234",
 * "865 555 1234", "1-865-555-1234" and "+1 (865) 555-1234".
 */
export function normalizePhoneDigits(value: string): string {
  let digits = value.replace(/\D/g, "");
  // Drop a US country code so pasted +1 numbers keep all 10 national digits.
  if (digits.length > 10 && digits.startsWith("1")) digits = digits.slice(1);
  return digits.slice(0, 10);
}

/**
 * Format a raw phone string into (XXX) XXX-XXXX as the user types.
 */
export function formatPhoneNumber(value: string): string {
  const digits = normalizePhoneDigits(value);
  if (digits.length === 0) return "";
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

/**
 * Strip formatting and return the 10 national digits from any entry.
 */
export function unformatPhone(value: string): string {
  return normalizePhoneDigits(value);
}

/**
 * Turn any accepted entry into E.164 (+1XXXXXXXXXX) for SMS delivery.
 * Returns "" when there are not exactly 10 national digits.
 */
export function toE164(value: string): string {
  const digits = normalizePhoneDigits(value);
  return digits.length === 10 ? `+1${digits}` : "";
}

/**
 * Returns a character counter string like "42 / 100"
 */
export function charCount(value: string, max: number): string {
  return `${value.length} / ${max}`;
}
